import React, {useState} from 'react'
import BasicSearch from "components/BasicSearch";
import MembersElement from "./MembersElement";
import Tr from "translations/Translations";
import AddIcon from '@material-ui/icons/AddBoxOutlined'
import Button from "components/Button";
import AddPurchasingGroupMemberPopup from "./AddPurchasingGroupMemberPopup";
import {makeStyles} from "@material-ui/core";
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    search: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    }
}))

function MembersList(
    {
        groupId,
        members,
        coordinatorView,
        editable,
        validationSection
    }) {
    const classes = useStyle();
    const [addWindowOpen, setAddWindowOpen] = useState(false);
    const [search, setSearch] = useState({});

    return (<div className={classes.root}>
        {!coordinatorView && <BasicSearch className={classes.search} doSearch={setSearch} label={Tr('search_member')}/>}
        {
            members.map((x, i) => (<MembersElement
                key={x.identity}
                index={i}
                groupId={groupId}
                member={x}
                search={search}
                coordinatorView={coordinatorView}
                editable={editable}
                validationSection={validationSection}
            />))
        }
        {
            !coordinatorView && <Button disabled={!editable} Icon={AddIcon} variant="outlined" onClick={() => setAddWindowOpen(true)}>{Tr('purchase_group_member_add')}</Button>
        }
        {(!coordinatorView && addWindowOpen) && <AddPurchasingGroupMemberPopup groupId={groupId} onClose={() => setAddWindowOpen(false)}/>}
    </div>)
}

MembersList.propTypes = {
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    members: PropTypes.array.isRequired,
    coordinatorView: PropTypes.bool.isRequired,
    editable: PropTypes.bool.isRequired
}

export default MembersList;